function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M34.02 52.534a18.148 18.148 0 1036.297 0 18.148 18.148 0 00-36.297 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.256 47.259l-8.787 11.714a2.268 2.268 0 01-3.421.245l-4.537-4.537M28.258 43.402H5.572a4.537 4.537 0 01-4.537-4.537V5.594a4.537 4.537 0 014.537-4.537h54.445a4.536 4.536 0 014.537 4.537v22.685"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.244 2.406l-30.449 24.36L2.342 2.406"
}));

function SvgEmailSent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72
  }, props), _ref);
}

export default SvgEmailSent;